var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "sc-modal",
    {
      attrs: { active: _vm.showAboutModal },
      on: {
        "update:active": function($event) {
          _vm.showAboutModal = $event
        },
        close: _vm.handleClose
      }
    },
    [
      _c(
        "sc-modal-card",
        { attrs: { title: _vm.modal.about.title } },
        [
          _c(
            "template",
            { attrs: { slot: "body" }, slot: "body" },
            [
              _c(
                "sc-tabs",
                [
                  _c(
                    "sc-tab-item",
                    { attrs: { label: "Sobre", icon: "file" } },
                    [
                      _c("p", { staticClass: "modal_about__field" }, [
                        _c("strong", [_vm._v("Descrição:")]),
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              this.selectedApp
                                ? this.selectedApp.description
                                : ""
                            ) +
                            "\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "modal_about__field" }, [
                        _c("strong", [_vm._v("Categoria:")]),
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              this.selectedApp ? this.selectedApp.category : ""
                            ) +
                            "\n            "
                        )
                      ]),
                      _vm._v(" "),
                      this.selectedApp.status === "INSTALLED"
                        ? _c("p", { staticClass: "modal_about__field" }, [
                            _c("strong", [_vm._v("ID Instalação:")]),
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  this.selectedApp
                                    ? this.selectedApp.installation_id
                                    : ""
                                ) +
                                "\n            "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      this.selectedApp.public_doc !== "Não informada."
                        ? _c("div", { staticClass: "modal_about__field" }, [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: this.selectedApp.public_doc,
                                  target: "_blank"
                                }
                              },
                              [_vm._v(" Documentação ")]
                            )
                          ])
                        : _vm._e()
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b5e1590", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b5e1590","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-integrations/components/modal/about/ModalAbout.vue
// module id = null
// module chunks = 